import React, { useState } from "react";
import DoctorOne from '../../assets/images/dashboard/profile-1.svg';
import { DoctorDetails, UploadDocument } from "../../components/componentIndex";
import { Button, CheckBox, CheckedImage, Input, Textarea } from "../../common/commonIndex";
import { useNavigate } from "react-router-dom";
import UploadIcon from '../../assets/images/upload-icon.svg';

const ReferralForm = () => {
    const navigate = useNavigate();
    const [checkBoxList, setCheckBoxList] = useState(['I agree to GutChek Terms and Conditions']);
    const [patientInfo, setPatientInfo] = useState({
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        mobileNumber: '',
        email: '',
        streetAddress: '',
        aptSuite: '',
        city: '',
        state: '',
        zipCode: '',
        referringProviderName: '',
        referringProviderNPI: '',
        patientDetailsOrNotes: '',
        medicalRecords: "",
        termsAndConditionsAccepted: false,
    });

    const [errors, setErrors] = useState({}); // To track validation errors

    const doctorInfo = {
        name: 'Jessica Johnson, MD',
        specialization: 'Gastroenterology',
        address: 'Novant Medical Center',
        rating: '4.9 (99)',
        photo: DoctorOne,
    };

    // Validation function for individual fields
    const validateField = (name, value) => {
        let error = '';
        switch (name) {
            case 'firstName':
                if (!value) error = 'First name is required';
                break;
            case 'lastName':
                if (!value) error = 'Last name is required';
                break;
            case 'email':
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!value) error = 'Email is required';
                else if (!emailPattern.test(value)) error = 'Invalid email format';
                break;
            case 'mobileNumber':
                const phonePattern = /^\d{10}$/;
                if (!value) error = 'Mobile number is required';
                else if (!phonePattern.test(value)) error = 'Invalid mobile number';
                break;
            case 'zipCode':
                const zipPattern = /^\d{5}$/;
                if (!value) error = 'Zip code is required';
                else if (!zipPattern.test(value)) error = 'Invalid zip code';
                break;
            case 'termsAndConditionsAccepted':
                if (!value) error = 'You must accept the terms and conditions';
                break;
            default:
                break;
        }
        return error;
    };

    const handleChange = (fieldName) => (event) => {
        setPatientInfo({ ...patientInfo, [fieldName]: event });

        const error = validateField(fieldName, event);
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setPatientInfo({ ...patientInfo, medicalRecords: file });

    };
    /* Callback function to handle radio button change */
    const handleRadioChange = (value) => {
        if (checkBoxList.includes(value)) {
            // If value is already selected, remove it from the array
            setCheckBoxList(checkBoxList.filter(item => item !== value));
            patientInfo.termsAndConditionsAccepted = false;
        } else {
            // Otherwise, add the value to the array
            setCheckBoxList([...checkBoxList, value]);
            patientInfo.termsAndConditionsAccepted = true;
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        navigate('/referral-confirmation');
        // Handle form submission here, e.g., send data to a server
    };

    return (
        <div className="custom-container">
            <div className="referral-form">
                <h4 className="page-title">Referral form</h4>
                <div className="row">
                    <div className="col-md-8">
                        <form className="insurance-card form-input-label">
                            <div className="">
                                <DoctorDetails doctorInformation={doctorInfo} />
                            </div>
                            <div className="divider my-3"></div>
                            <div>
                                <h5 className="referrals-title mb-3">Patient information</h5>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <div className={`input-group form-item ${patientInfo.firstName?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'text'} id={'firstName'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('firstName')}
                                                value={patientInfo.firstName} />
                                            <label htmlFor="firstName" className={patientInfo.firstName?.trim() !== '' ? 'is-active active' : 'active'} >Patient first name</label>
                                            {patientInfo.firstName?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.firstName && <p className="is-error">{errors.firstName}</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <div className={`input-group ${patientInfo.lastName?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'text'} id={'lastName'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('lastName')}
                                                value={patientInfo.lastName} />
                                            <label htmlFor="lastName" className={patientInfo.lastName?.trim() !== '' ? 'is-active active' : 'active'}>Patient last name</label>
                                            {patientInfo.lastName?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.lastName && <p className="is-error">{errors.lastName}</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <div className={`input-group ${patientInfo.dateOfBirth?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'text'} id={'dateOfBirth'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('dateOfBirth')}
                                                value={patientInfo.dateOfBirth} />
                                            <label htmlFor="dateOfBirth" className={patientInfo.dateOfBirth?.trim() !== '' ? 'is-active active' : 'active'}>Patient date of birth</label>
                                            {patientInfo.dateOfBirth?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.dateOfBirth && <p className="is-error">{errors.dateOfBirth}</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <div className={`input-group ${patientInfo?.mobileNumber?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'text'} id={'mobileNumber'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('mobileNumber')}
                                                value={patientInfo.mobileNumber} isPhoneNumber={true} />
                                            <label htmlFor="mobileNumber" className={patientInfo.mobileNumber?.trim() !== '' ? 'is-active active' : 'active'}>Patient mobile number</label>
                                            {patientInfo?.mobileNumber?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.mobileNumber && <p className="is-error">{errors.mobileNumber}</p>}
                                    </div>
                                    <div className="col-12">
                                        <div className={`input-group ${patientInfo.email?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'email'} id={'email'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('email')}
                                                value={patientInfo.email} />
                                            <label htmlFor="email" className={patientInfo.email?.trim() !== '' ? 'is-active active' : 'active'}>Patient email id</label>
                                            {patientInfo.email?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.email && <p className="is-error">{errors.email}</p>}
                                    </div>
                                    <div className="col-12">
                                        <div className={`input-group ${patientInfo.streetAddress?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'text'} id={'streetAddress'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('streetAddress')}
                                                value={patientInfo.streetAddress} />
                                            <label htmlFor="streetAddress" className={patientInfo.streetAddress?.trim() !== '' ? 'is-active active' : 'active'}>Street address</label>
                                            {patientInfo.streetAddress?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.streetAddress && <p className="is-error">{errors.streetAddress}</p>}
                                    </div>
                                    <div className="col-12">
                                        <div className={`input-group ${patientInfo.aptSuite?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'text'} id={'aptSuite'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('aptSuite')}
                                                value={patientInfo.aptSuite} />
                                            <label htmlFor="aptSuite" className={patientInfo.aptSuite?.trim() !== '' ? 'is-active active' : 'active'}>Apt, suite (optional)</label>
                                            {patientInfo.aptSuite?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.aptSuite && <p className="is-error">{errors.aptSuite}</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <div className={`input-group ${patientInfo.city?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'text'} id={'city'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('city')}
                                                value={patientInfo.city} />
                                            <label htmlFor="city" className={patientInfo.city?.trim() !== '' ? 'is-active active' : 'active'}>City</label>
                                            {patientInfo.city?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.city && <p className="is-error">{errors.city}</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <div className={`input-group ${patientInfo.state?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'text'} id={'state'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('state')}
                                                value={patientInfo.state} />
                                            <label htmlFor="state" className={patientInfo.city?.trim() !== '' ? 'is-active active' : 'active'}>State</label>
                                            {patientInfo.state?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.state && <p className="is-error">{errors.state}</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <div className={`input-group ${patientInfo.zipCode?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'text'} id={'zipCode'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('zipCode')}
                                                value={patientInfo.zipCode} isZipCode={true} />
                                            <label htmlFor="zipCode" className={patientInfo.zipCode?.trim() !== '' ? 'is-active active' : 'active'}>ZIP code</label>
                                            {patientInfo.zipCode?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.zipCode && <p className="is-error">{errors.zipCode}</p>}
                                    </div>

                                    <div className="divider my-3"></div>

                                    <h5 className="referrals-title mb-3">Referring Provider</h5>

                                    <div className="col-12">
                                        <div className={`input-group ${patientInfo.referringProviderName?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'text'} id={'referringProviderName'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('referringProviderName')}
                                                value={patientInfo.referringProviderName} />
                                            <label htmlFor="referringProviderName" className={patientInfo.referringProviderName?.trim() !== '' ? 'is-active active' : 'active'}>Referring provider name</label>
                                            {patientInfo.referringProviderName?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.referringProviderName && <p className="is-error">{errors.referringProviderName}</p>}
                                    </div>
                                    <div className="col-12">
                                        <div className={`input-group ${patientInfo.referringProviderNPI?.trim() !== '' ? 'valid' : ''}`}>
                                            <Input inputType={'text'}  id={'referringProviderNPI'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('referringProviderNPI')}
                                                value={patientInfo.referringProviderNPI} />
                                            <label htmlFor="referringProviderNPI" className={patientInfo.referringProviderNPI?.trim() !== '' ? 'is-active active' : 'active'}>Referring provider NPI</label>
                                            {patientInfo.referringProviderNPI?.trim() !== '' && (
                                                <CheckedImage />
                                            )}
                                        </div>
                                        {errors.referringProviderNPI && <p className="is-error">{errors.referringProviderNPI}</p>}
                                    </div>
                                    <div className="col-12">
                                        <div className={`input-group ${patientInfo.patientDetailsOrNotes?.trim() !== '' ? 'valid' : ''}`}>
                                            <Textarea inputType={'text'} id={'patientDetailsOrNotes'} rows={5} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('patientDetailsOrNotes')}
                                                value={patientInfo.patientDetailsOrNotes} />
                                            <label htmlFor="patientDetailsOrNotes" className={patientInfo.referringProviderNPI?.trim() !== '' ? 'is-active active' : 'active'}>Add any relevant patient details or notes  (optional)</label>
                                        </div>
                                        {errors.patientDetailsOrNotes && <p className="is-error">{errors.patientDetailsOrNotes}</p>}
                                    </div>

                                    <p className="attach-document-title">Optional: Attach relevant medical records or documents</p>
                                    {/* document-uploads */}
                                    <div className="mt-3 referral-upload">
                                        <UploadDocument handleUploadFileChange={handleFileChange} value={patientInfo.medicalRecords} name={'Upload'} setValue={setPatientInfo}
                                            imgIcon={UploadIcon}
                                            buttonName={'Upload'}
                                            btnClass={'btn-upload'}
                                            btnType={'button'}

                                        />
                                    </div>
                                    <div className="is-agree">
                                        <CheckBox
                                            checkBox="gender"
                                            name={'I agree to GutChek Terms and Conditions'}
                                            id={0}
                                            onCheckBoxChange={handleRadioChange}
                                            formData={['I agree to GutChek Terms and Conditions']}
                                            isAllergiesCheck={true}
                                            value={checkBoxList}
                                            setValue={setCheckBoxList}
                                        />
                                        {errors.termsAndConditionsAccepted && <p className="is-error">{errors.termsAndConditionsAccepted}</p>}
                                    </div>
                                    <div className="justify-content-start">
                                        <Button btnType={'submit'}
                                            btnClass={'btn-primary question-btn'}
                                            btnName={'Submit Referral'}
                                            isDisabled={true}
                                            onClick={handleSubmit}
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-md-4">
                        <div className="referrals-form-description">
                            <h5 className="referrals-title">Referrals</h5>
                            <p className="description">
                                To submit a referral for a GutChek provider, please fill out the form. Once submitted, the patient will receive an invitation via text message to download our app or visit our website to self-schedule their procedure.
                            </p>
                            <p className="description">
                                If the patient does not schedule within the allotted time, we will follow up via phone and, if necessary, by mail to ensure they complete their booking.
                            </p>
                            <p className="description">
                                Upon submission, you will receive a confirmation number and a PDF copy of the referral for your records.
                            </p>
                            <p className="please-note">
                                Please Note:<span>Referrals through GutChek are for open access colonoscopy and endoscopy procedures only, not clinic visits. Only healthcare professionals can submit referrals using this form.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ReferralForm;